import { render } from "./userPass.vue?vue&type=template&id=2dfd35fb&scoped=true"
import script from "./userPass.vue?vue&type=script&lang=js"
export * from "./userPass.vue?vue&type=script&lang=js"

import "./userPass.vue?vue&type=style&index=0&id=2dfd35fb&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfd35fb"]])

export default __exports__